<template>
    <div class="col">
        <div class="form-row">
            <div class="form-group col-md-6">
                <label>sigma_smooth</label>

                <input
                    type="number"
                    class="form-control"
                    name="sigma_smooth"
                    v-model="form.sigma_smooth"
                    :class="form.errors.set_scale_divided ? 'is-invalid' : ''"
                />

                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.sigma_smooth"
                >
                    {{ error }}
                </span>
            </div>

            <!-- sigma conv-->
            <div class="form-group col-md-6">
                <label>sigma_conv / unit</label>
                <div class="input-group">
                    <input
                        type="number"
                        class="form-control"
                        :class="form.errors.sigma_conv ? 'is-invalid' : ''"
                        name="sigma_conv"
                        v-model="form.sigma_conv"
                    />
                </div>
                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.sigma_conv"
                >
                    {{ error }}
                </span>
            </div>

            <!-- r_min -->
            <div class="form-group col-md-6">
                <label>r_min</label>

                <div class="input-group">
                    <input
                        type="number"
                        class="form-control"
                        :class="form.errors.sigma_conv ? 'is-invalid' : ''"
                        name="r_min"
                        v-model="form.r_min"
                    />
                </div>
                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.r_min"
                >
                    {{ error }}
                </span>
            </div>
            <!-- r_max -->
            <div class="form-group col-md-6">
                <label>r_max</label>
                <div class="input-group">
                    <input
                        type="number"
                        class="form-control"
                        :class="form.errors.sigma_conv ? 'is-invalid' : ''"
                        name="r_max"
                        v-model="form.r_max"
                    />
                </div>
                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.r_max"
                >
                    {{ error }}
                </span>
            </div>
            <!-- r_step -->
            <div class="form-group col-md-6">
                <label class="control-label">r_step</label>
                <div class="input-group">
                    <input
                        type="number"
                        class="form-control"
                        :class="form.errors.sigma_conv ? 'is-invalid' : ''"
                        name="r_step"
                        v-model="form.r_step"
                    />
                </div>
                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.r_step"
                >
                    {{ error }}
                </span>
            </div>
            <!-- min loop length-->
            <div class="form-group col-md-6">
                <label>min_loop_length</label>

                <input
                    type="number"
                    class="form-control"
                    :class="form.errors.min_loop_length ? 'is-invalid' : ''"
                    name="min_loop_length"
                    v-model="form.min_loop_length"
                />

                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.min_loop_length"
                >
                    {{ error }}
                </span>
            </div>

            <!--  delete_worst_sections -->

                <div class="form-group col-md-6">
                    <label>Delete worst sections</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input type="checkbox" id="save_loop_area" v-model="
                                            form.delete_worst_sections
                                        " />
                            </div>
                        </div>
                        <input type="number" class="form-control" :class="
                                    form.errors.delete_worst_sections_value
                                        ? 'is-invalid'
                                        : ''
                                " name="save_loop_area_value" v-model="form.delete_worst_sections_value" />
                        <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                                    .delete_worst_sections_value" step="1">
                            {{ error }}
                        </span>
                        <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors
                                    .delete_worst_sections">
                            {{ error }}
                        </span>
                    </div>
                </div>
            <div class="form-group col-md-6"></div>

            <!-- use_modified_hessian -->
            <div class="form-group col-md-6">
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :class="
                            form.errors.use_modified_hessian ? 'is-invalid' : ''
                        "
                        id="use_modified_hessian"
                        v-model="form.use_modified_hessian"
                    />
                    <label
                        class="custom-control-label"
                        for="use_modified_hessian"
                        >use modified hessian</label
                    >
                </div>

                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.use_modified_hessian"
                >
                    {{ error }}
                </span>
            </div>

            <!--no_rescaling-->
            <div class="form-group col-md-6">
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :class="form.errors.no_rescaling ? 'is-invalid' : ''"
                        id="no_rescaling"
                        v-model="form.no_rescaling"
                    />
                    <label class="custom-control-label" for="no_rescaling"
                        >no rescaling</label
                    >
                </div>

                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.no_rescaling"
                >
                    {{ error }}
                </span>
            </div>


            <!-- auto startpoints -->
            <div class="form-group col-md-6">
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="auto_startpoint"
                        v-model="form.auto_startpoint"
                    />
                    <label class="custom-control-label" for="auto_startpoint"
                        >auto_startpoint</label
                    >
                </div>

                <span
                    class="help-block text-danger"
                    :key="index"
                    v-for="(error, index) in form.errors.auto_startpoint"
                >
                    {{ error }}
                </span>
            </div>
            <!--
            <div class="form-row" v-if="form.auto_startpoint">
                <div class="form-group col">
                    <label>auto_startpoint_1</label>

                    <input
                        type="number"
                        class="form-control"
                        name="auto_startpoint"
                        :class="
                            form.errors.auto_startpoint_1 ? 'is-invalid' : ''
                        "
                        v-model="form.auto_startpoint_1"
                    />

                    <span
                        class="help-block text-danger"
                        :key="index"
                        v-for="(error, index) in form.errors.auto_startpoint_1"
                    >
                        {{ error }}
                    </span>
                </div>

                <div class="form-group col">
                    <label>auto_startpoint_2</label>

                    <input
                        type="number"
                        class="form-control"
                        name="auto_startpoint_2"
                        v-model="form.auto_startpoint_2"
                        :class="
                            form.errors.auto_startpoint_2 ? 'is-invalid' : ''
                        "
                    />

                    <span
                        class="help-block text-danger"
                        :key="index"
                        v-for="(error, index) in form.errors.auto_startpoint_2"
                    >
                        {{ error }}
                    </span>
                </div>

                <div class="form-group col">
                    <label>auto_startpoint_3</label>

                    <input
                        type="number"
                        class="form-control"
                        :class="
                            form.errors.auto_startpoint_3 ? 'is-invalid' : ''
                        "
                        name="auto_startpoint_3"
                        v-model="form.auto_startpoint_3"
                    />

                    <span
                        class="help-block text-danger"
                        :key="index"
                        v-for="(error, index) in form.errors.auto_startpoint_3"
                    >
                        {{ error }}
                    </span>
                </div>
            </div>-->
            
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

export default {
    props: ["form"],
    components: {
        VSwatches
    },
    data() {
        return {
        }
    },
    methods: {
        copyObject(obj) {
            var cp = {};
            for (var o in obj) {
                cp[o] = obj[o];
            }
            return cp;
        },
        submit() {
            axios
                .post("/task", this.form)
                .then(response => {
                    console.log("successful");
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.form.errors = error.response.data.errors;
                    }
                });
        }
    }
};
</script>
